import { TShiftManagementActions } from './shift-management.actions';
import { TShiftManagementState, TShiftManagementActionType } from './shift-management.models';

const initialState: TShiftManagementState = {
  allShiftsRes: null,
  lineShiftsRes: null,
};

export function shiftManagementReducer(state = initialState, action: TShiftManagementActions): TShiftManagementState {
  switch (action.type) {
    case TShiftManagementActionType.FetchAllShiftsSuccess:
      return { ...state, allShiftsRes: action.payload };
    case TShiftManagementActionType.FetchLineShiftsSuccess:
      return { ...state, lineShiftsRes: action.payload };
    default:
      return state;
  }
}
